"use strict";

var isSymbol = require("./is-symbol");

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es6-symbol/validate-symbol.js
// module id = ../../../node_modules/es6-symbol/validate-symbol.js
// module chunks = 1